export const initialState = {
    user: null,
    playlists: [],
    playlist_id_now: '',
    playlist_song_love: [],
    playing: false,
    playing_loading: false,
    song_playing: {
        id: '',
        name_vi: '',
        name_en: '',
        singer: '',
        avatar: '',
        subtitle_vi: '',
        subtitle_en: '',
        view: 0,
        url_audio: '',
        time: 0,
        bg_color: '',
        cover: ''

    },
    time_playing: {
        played: 0.0,
        playedSeconds: 0,
        loaded: 0.0,
        loadedSeconds: 0,
        totalTime: 0
    },
    current_second: 0,
    volume: window.innerWidth <= 600 ? 1.0 : 0.5,
    volume_old: 0.5,
    loop: 0, // 0 => no loop , 1 => loop one song , 2 lopp all playlist
    shuffle: false,
    item: null,
    lang: 'vi',
    loading_page: false,
    playing_song_by_id: '',
    seek_to: false,
    noti:'',
    search: '',
    playback_rate: 1.0

};
const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_USER':
            return {
                ...state,
                user: action.user
            }
        case 'SET_LANG':
            return {
                ...state,
                lang: action.lang
            }
        case 'SET_PLAYLISTS':
            return {
                ...state,
                playlists: action.playlists
            }
        case 'SET_PLAYING':
            return {
                ...state,
                playing: action.playing
            }
        case 'SET_PLAYING_LOADING':
            return {
                ...state,
                playing_loading: action.playing_loading
            }
        case 'SET_SONG_PLAYING':
            return {
                ...state,
                song_playing: action.song_playing
            }
        case 'SET_TIME_PLAYING':
            return {
                ...state,
                time_playing: action.time_playing
            }
        case 'REWIND_CURRENT_SECOND':
            return {
                ...state,
                current_second: action.current_second
            }
        case 'SET_VOLUME':
            return {
                ...state,
                volume: action.volume
            }
        case 'SET_VOLUME_OLD':
            return {
                ...state,
                volume_old: action.volume_old
            }
        case 'SET_LOOP':
            return {
                ...state,
                loop: action.loop
            }
        case 'SET_SHUFFLE':
            return {
                ...state,
                shuffle: action.shuffle
            }
        case 'SET_LOADING_PAGE':
            return {
                ...state,
                loading_page: action.loading_page
            }
        case 'SET_PLAYING_SONG_BY_ID':
            return {
                ...state,
                playing_song_by_id: action.playing_song_by_id
            }
        case 'SET_PLAYLIST_ID_NOW':
            return {
                ...state,
                playlist_id_now: action.playlist_id_now
            }
        case 'SET_SEEK_TO':
            return {
                ...state,
                seek_to: action.seek_to
            }
        case 'SET_PLAYLIST_SONG_LOVE':
            return {
                ...state,
                playlist_song_love: action.playlist_song_love
            }
        case 'SET_NOTI':
            return {
                    ...state,
                    noti: action.noti
                }
        case 'SET_SEARCH':
            return {
                    ...state,
                    search: action.search
                }
        case 'SET_PLAYBACK_RATE':
            return {
                ...state,
                playback_rate: action.playback_rate
        }       
        default:
            return state;
    }
};
export default reducer;